import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from '../../shared';
import {CmsLabelContainerModel} from '../../../../../../models/aggregates/cms/label';


@Injectable({providedIn: 'root'})

export class CmsLabelService extends BaseApiTemplateService<CmsLabelContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'labels';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'labels';
    this.httpClient = http;
  }
}
